import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPeopleIcon = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 138,
	height: 108,
	viewBox: "0 0 138 108",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M68.8438 52.3125C79.5615 52.3125 88.25 43.624 88.25 32.9062C88.25 22.1885 79.5615 13.5 68.8438 13.5C58.126 13.5 49.4375 22.1885 49.4375 32.9062C49.4375 43.624 58.126 52.3125 68.8438 52.3125Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68 60.75C61.4513 60.8976 55.0884 63.4593 49.7312 68.105C44.374 72.7507 40.2678 79.2675 37.9417 86.816C37.6682 87.673 37.5696 88.5997 37.6546 89.5147C37.7396 90.4297 38.0055 91.305 38.4289 92.0637C38.8524 92.8223 39.4205 93.4412 40.0834 93.866C40.7462 94.2907 41.4835 94.5083 42.2305 94.4996H93.7604C94.5081 94.5102 95.2465 94.2939 95.9106 93.87C96.5746 93.446 97.144 92.8273 97.5685 92.0684C97.993 91.3094 98.2597 90.4334 98.3451 89.5175C98.4306 88.6016 98.3321 87.6739 98.0583 86.816C95.7322 79.2675 91.626 72.7507 86.2687 68.105C80.9115 63.4593 74.5487 60.8976 68 60.75Z",
			fill: "#006ADC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.125 60.75C15.7372 60.75 8.9375 53.9503 8.9375 45.5625C8.9375 37.1747 15.7372 30.375 24.125 30.375C32.5128 30.375 39.3125 37.1747 39.3125 45.5625C39.3125 53.9503 32.5128 60.75 24.125 60.75Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.002 67.5C29.0689 67.5886 34.9569 69.5302 36.7058 71.1818C37.9761 72.3816 37.6585 74.25 37.3409 75.1705C36.862 76.5586 36.3694 77.3182 35.753 78.5455C35.1366 79.7727 35.1178 79.7727 34.4826 81.3068C33.8474 82.8409 33.8474 82.8409 33.5298 84.0682C33.2122 85.2955 31.9419 87.75 29.0835 87.7498H4.07048C3.49192 87.7561 2.9206 87.6264 2.40681 87.372C1.89302 87.1176 1.4525 86.7464 1.12403 86.291C0.795555 85.8356 0.589195 85.3101 0.523106 84.7605C0.45702 84.211 0.53323 83.6544 0.745033 83.1396C2.54483 78.6105 5.7219 74.7004 9.86694 71.913C14.012 69.1256 18.9351 67.5886 24.002 67.5Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.562 60.75C121.95 60.75 128.75 53.9503 128.75 45.5625C128.75 37.1747 121.95 30.375 113.562 30.375C105.175 30.375 98.375 37.1747 98.375 45.5625C98.375 53.9503 105.175 60.75 113.562 60.75Z",
			fill: "#002E5F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M112.617 67.5C107.32 67.5886 101.164 69.5302 99.336 71.1818C98.0079 72.3816 98.3399 74.25 98.672 75.1705C99.1727 76.5586 99.6877 77.3182 100.332 78.5455C100.977 79.7727 100.996 79.7727 101.66 81.3068C102.324 82.8409 102.324 82.8409 102.656 84.0682C102.988 85.2955 104.316 87.75 107.305 87.7498H133.455C134.06 87.7561 134.657 87.6264 135.194 87.372C135.731 87.1176 136.192 86.7464 136.535 86.291C136.879 85.8356 137.094 85.3101 137.163 84.7605C137.232 84.211 137.153 83.6544 136.931 83.1396C135.05 78.6105 131.728 74.7004 127.395 71.913C123.061 69.1256 117.914 67.5886 112.617 67.5Z",
			fill: "#002E5F"
		})
	]
});
const ForwardRef = forwardRef(SvgPeopleIcon);
export default ForwardRef;
